import { render } from "./GuessTheVerseQuestion.vue?vue&type=template&id=2689c1d6&ts=true"
import script from "./GuessTheVerseQuestion.vue?vue&type=script&lang=ts"
export * from "./GuessTheVerseQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__